import React from 'react';
import spinner from "../assets/img/loader-new.svg";
import CompanyLogo from "../assets/img/m-comp-logo-white.png";

export default function Loader() {
    return (
        <div className="spinner-loader">
            <div className="form-header">
                <img src={CompanyLogo} alt="Loading..." />
            </div>
            <img src={spinner} alt="Loading..." />
        </div>
    )
}
